<script lang="ts">
  import { faCheck } from '@itdev-fortawesome/pro-solid-svg-icons/faCheck';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import type { Snippet } from 'svelte';
  import DropdownItem from './bootstrap/DropdownItem.svelte';

  interface Props {
    active?: boolean;
    onclick?: () => void;
    children?: Snippet;
  }

  let { active = false, onclick = () => {}, children }: Props = $props();
</script>

<DropdownItem {active} {onclick}>
  <div class="has-icon">
    <div class="flex-grow-1">{@render children?.()}</div>
    <div class="dropdown-item-icon">
      {#if active}
        <FontAwesomeIcon icon={faCheck} />
      {/if}
    </div>
  </div>
</DropdownItem>

<style>
  .has-icon {
    display: flex;
    align-items: baseline;
    gap: 0.75rem;
  }

  .dropdown-item-icon {
    width: 1em;
  }
</style>
